import "./croppie.css"
import  React,{useState,useEffect} from "react"
import Croppie from "croppie"



let element;
let resize;

const Crop=(props)=> {
    const [image, setImage] = useState();

    let cropOption={
        viewport: { width: 400, height: props.size },
        boundary: { width: 1000, height: 800 },
        showZoomer: true,
        enableResize: false,
        enableOrientation: false,
        mouseWheelZoom: 'ctrl'
    };



    useEffect(()=>{
        if (!props.show){
            init();
           //console.log(props.image);
        }


    });

    function init() {
        if (resize) return;

       element = document.getElementById("resizer-demo");
       resize = new Croppie(element,cropOption);
       handleImage();
    }
    
    function destroy() {
        if (!resize) return;
        resize.destroy();
        resize = null;
    }


    function Done() {
        resize.result("base64").then(base64 => {
            setImage(base64);
            return props.done(base64);
        });
        destroy();

    }



    function handleImage() {

        if(props.image) {
            resize.bind({
                url:props.image,
                zoom: 0
            });



        }

    }




    return (
        <div className="zoom" style={!props.show ? {display: 'block'} : {display: 'none'}}>

            <button className="form-control-sm btn btn-sm btn-primary" onClick={Done}>Done</button>

            <div id="resizer-demo"></div>

        </div>
    )
};
export default Crop;
